<template>

<slot />

</template>